import { state } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { Module } from 'vuex';
import { StoreType } from '@/types/store/store.type';
import { LangStoreType } from '@/types/store/lang-store.type';

const namespaced: boolean = true;
export const lang: Module<LangStoreType, StoreType> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
